exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!../node_modules/postcss-loader/lib/index.js??postcss!@angular/material/prebuilt-themes/deeppurple-amber.css"), "");

// module
exports.push([module.id, "h1{\n   color:blue;\n}\n#copyright {\nheight : 30px;\nbackground-color : #B5B7B9;\nborder-top : 1px solid white;\nposition: relative;\n\n}\n.erralert{\n\t\n  max-width:350px;\n  padding:20px 20px;\n  \n  margin:0 auto 15px;\n  margin-top:50px;\n  border-radius:2px;\n  \n}\n.table tr.active td {\n  background-color:#123456 !important;\n  color: white;\n}\n.mandatory{\n    font-size: 18px;\n    color: red\n}\n.mat-form-field-underline{\n  display: none\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// D:/ESealStore_AJS/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!D:/ESealStore_AJS/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!D:/ESealStore_AJS/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/styles.css
// module chunks = styles